import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { DatabaseProvider } from "@/contexts/DatabaseContext";
import { ToastProvider } from "@/contexts/ToastContext";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ToastProvider>
        <DatabaseProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            <AppRoutes />
          </BrowserRouter>
        </DatabaseProvider>
      </ToastProvider>
    </I18nextProvider>
  );
}

export default App;
